import { LabelProps, Label as RACLabel } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

export interface ClarionLabelProps extends LabelProps {
  children: React.ReactNode;
}

export function ClarionLabel({ children, className, ...props }: ClarionLabelProps) {
  return (
    <RACLabel
      {...props}
      className={twMerge(
        'text-sm text-gray-700 dark:text-gray-200 font-medium cursor-default w-fit block mb-1',
        className,
      )}
    >
      {children}
    </RACLabel>
  );
}
